import { useEffect, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { fetchProjectPlanSelectRows } from '../../../../lib/snapshotRows'
import { ProjectPlanSelectRow } from '../model'

type UseProjectPlanSelectDataProps = {
  snapshotUuid: string
}

export const useProjectPlanSelectData = ({
  snapshotUuid,
}: UseProjectPlanSelectDataProps) => {
  const [rows, setRows] = useState<ProjectPlanSelectRow[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const { fetchMasterSchedule } = useProjectPlanSnapshotRepository()

  useEffect(() => {
    const cancelled = { current: false }
    setIsLoading(true)
    fetchProjectPlanSelectRows(snapshotUuid, fetchMasterSchedule)
      .then(result => {
        if (!cancelled.current) setRows(result)
      })
      .catch(error => {
        // 失敗時のユーザー通知は共通API層(lib/commons/api)が行うため、ここでは状態のみ戻す
        console.error('Failed to fetch project plan data:', error)
        if (!cancelled.current) setRows([])
      })
      .finally(() => {
        if (!cancelled.current) setIsLoading(false)
      })
    return () => {
      cancelled.current = true
    }
  }, [snapshotUuid, fetchMasterSchedule])

  return { rows, isLoading }
}
